"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var system_1 = require("@mui/system");
var prism_icons_1 = require("@octanner/prism-icons");
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var Button_1 = __importDefault(require("../Button"));
var colors_1 = require("../ThemeProvider/colors");
var Typography_1 = __importDefault(require("../Typography"));
var styles_1 = require("./styles");
var hasInvalidFileExtensions = function (files, supportedExtensions) {
    return Object.values(files).some(function (file) {
        var ext = file.name.split('.').slice(-1)[0];
        return !supportedExtensions.includes(ext);
    });
};
var rootVariantStyles = {
    sm: { display: 'flex', flexDirection: 'row', height: 56, gridGap: 16 },
    md: {
        display: 'flex',
        flexDirection: 'column',
        height: 128,
        justifyContent: 'center',
        gridGap: 6,
    },
};
var dragTextStyles = {
    sm: { flex: '1 1 auto' },
    md: {
        textAlign: 'center',
    },
};
var FileUpload = function (_a) {
    var onChange = _a.onChange, supportedExtensions = _a.supportedExtensions, testid = _a["data-testid"], _b = _a.variant, variant = _b === void 0 ? 'sm' : _b, sampleFileText = _a.sampleFileText, onSampleFileClick = _a.onSampleFileClick, _c = _a.multiple, multiple = _c === void 0 ? false : _c, helperText = _a.helperText, _d = _a.error, error = _d === void 0 ? false : _d, onError = _a.onError;
    var _e = __read((0, react_1.useState)(), 2), inputRef = _e[0], setInputRef = _e[1];
    var _f = __read((0, react_1.useState)(), 2), formRef = _f[0], setFormRef = _f[1];
    var t = (0, react_i18next_1.useTranslation)().t;
    var handleClick = function (e) {
        e.stopPropagation();
        if (!inputRef)
            return;
        inputRef.click();
    };
    var stopDefaults = function (e) {
        e.stopPropagation();
        e.preventDefault();
    };
    var handleChange = function (files) {
        if (!files || !files.length)
            return;
        if (hasInvalidFileExtensions(files, supportedExtensions)) {
            onError === null || onError === void 0 ? void 0 : onError('invalid-extension');
            return;
        }
        if (!multiple && files.length > 1) {
            onError === null || onError === void 0 ? void 0 : onError('multiple-files');
            return;
        }
        onChange(files);
    };
    var handleSelect = function (e) {
        if (!e.target.files)
            return;
        handleChange(e.target.files);
        if (!formRef)
            return;
        formRef.reset();
    };
    var handleDrop = function (e) {
        stopDefaults(e);
        var files = e.dataTransfer.files;
        handleChange(files);
    };
    var iconSize = 16;
    return (react_1.default.createElement(system_1.Box, { "data-testid": testid },
        react_1.default.createElement(system_1.Box, { component: "section", onClick: handleClick, sx: __assign(__assign(__assign({}, rootVariantStyles[variant]), { px: 5, alignItems: 'center', width: '100%', border: "2px dashed ".concat(colors_1.tannerGray['200']), borderRadius: '8px', backgroundColor: colors_1.tannerGray['50'], transitionProperty: 'color,background-color,border-color', transitionDelay: '0ms', transitionDuration: '250ms', transitionTimingFunction: 'ease', '&:hover': __assign({ cursor: 'pointer', backgroundColor: colors_1.tannerGray[100], borderColor: colors_1.tannerGray[300] }, (error && { borderColor: colors_1.tannerSemantic.error.color })), '&:active': __assign({ backgroundColor: colors_1.tannerGray['200'], borderColor: colors_1.tannerGray['400'] }, (error && { borderColor: colors_1.tannerSemantic.error.color })) }), (error && { borderColor: colors_1.tannerSemantic.error.color })), onDragOver: stopDefaults, onDrop: handleDrop },
            react_1.default.createElement(prism_icons_1.Upload, { sx: {
                    color: colors_1.tannerBlue['500'],
                    height: iconSize,
                    width: iconSize,
                    flex: '0 0 auto',
                } }),
            react_1.default.createElement(system_1.Box, { sx: dragTextStyles[variant] },
                react_1.default.createElement(Typography_1.default, null, t('prism-header:drag-files-here', 'Drag files here')),
                react_1.default.createElement(Typography_1.default, { variant: "body2", sx: { color: colors_1.tannerGray['700'] }, "data-testid": "supported-extensions" }, supportedExtensions.map(function (ext) { return '.' + ext; }).join(', '))),
            react_1.default.createElement(Button_1.default, { variant: "text", sx: { flex: '0 0 auto' }, onClick: handleClick },
                react_1.default.createElement(styles_1.SelectButtonText, null, t('prism-header:select-files', 'Select files')),
                react_1.default.createElement("form", { ref: function (e) { return setFormRef(e !== null && e !== void 0 ? e : undefined); } },
                    react_1.default.createElement("input", { ref: function (e) { return setInputRef(e !== null && e !== void 0 ? e : undefined); }, hidden: true, multiple: multiple, type: "file", onChange: handleSelect, "data-testid": testid ? "".concat(testid, ":input") : undefined })))),
        react_1.default.createElement(styles_1.HelpTextButtonContainer, null,
            helperText && (react_1.default.createElement(styles_1.HelperText, { error: error, "data-testid": "helper-text" }, helperText)),
            sampleFileText && (react_1.default.createElement(styles_1.DownloadButton, { size: "small", variant: "text", color: "secondary", buttonType: "secondary", "data-testid": "download-button", onClick: onSampleFileClick }, sampleFileText)))));
};
exports.default = FileUpload;
//# sourceMappingURL=index.js.map